module.exports = __webpack_public_path__ + "img/icon-android.e52ac7bd.svg";